/** Locale-aware formatters. */

export const formatDate = (d: Date | string | null | undefined, opts?: Intl.DateTimeFormatOptions): string => {
  if (d === null || d === undefined || d === "") return "—";
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en", opts ?? { dateStyle: "medium" }).format(date);
};

export const formatRelative = (d: Date | string | null | undefined): string => {
  if (d === null || d === undefined || d === "") return "—";
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date.getTime())) return "—";
  const diff = (Date.now() - date.getTime()) / 1000;
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
  if (diff < 60)        return rtf.format(-Math.round(diff), "second");
  if (diff < 3600)      return rtf.format(-Math.round(diff / 60), "minute");
  if (diff < 86400)     return rtf.format(-Math.round(diff / 3600), "hour");
  if (diff < 604800)    return rtf.format(-Math.round(diff / 86400), "day");
  if (diff < 2592000)   return rtf.format(-Math.round(diff / 604800), "week");
  if (diff < 31536000)  return rtf.format(-Math.round(diff / 2592000), "month");
  return rtf.format(-Math.round(diff / 31536000), "year");
};

export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let i = -1;
  let v = bytes;
  do { v /= 1024; i++; } while (v >= 1024 && i < units.length - 1);
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
};

export const formatCount = (n: number): string => new Intl.NumberFormat("en").format(n);

export const initials = (name: string | undefined | null, max = 2): string => {
  if (!name) return "?";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((p) => p[0]?.toUpperCase())
    .slice(0, max)
    .join("");
};
